import styled from "styled-components";

export const DetailPage = styled.div`
  padding: 24px;
  max-width: 900px;
`;

export const BackBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 20px;
  color: #ff6b35;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const DetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const DetailTitle = styled.h1`
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 600;
  color: #1f2937;
`;

export const DetailSub = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
`;

export const Card = styled.section`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
`;

export const CardTitle = styled.h3`
  margin: 0 0 14px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InfoLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const InfoValue = styled.span`
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
  word-break: break-word;
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
  white-space: pre-wrap;
`;

export const MetaList = styled.dl`
  margin: 0;
  display: grid;
  gap: 10px;
`;

export const MetaRow = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`;

export const MetaDt = styled.dt`
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
`;

export const MetaDd = styled.dd`
  margin: 0;
  font-size: 14px;
  color: #111827;
  word-break: break-word;
`;

export const Thread = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Bubble = styled.div`
  align-self: ${(p) => (p.$admin ? "flex-end" : "flex-start")};
  max-width: 75%;
  background: ${(p) => (p.$admin ? "#fff7f2" : "#f9fafb")};
  border: 1px solid ${(p) => (p.$admin ? "#fed7aa" : "#e5e7eb")};
  border-radius: 12px;
  padding: 12px 16px;
`;

export const BubbleMeta = styled.div`
  font-size: 11px;
  color: #9ca3af;
  margin-bottom: 6px;
`;

export const BubbleBody = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
`;

export const EmptyThread = styled.p`
  margin: 0;
  font-size: 14px;
  color: #9ca3af;
`;

export const ReplySection = styled.div`
  margin-top: 4px;
`;

export const ReplyActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

export const AttachGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;

  a {
    font-size: 13px;
    color: #ff6b35;
  }
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
  background: ${(p) => p.$bg || "#f3f4f6"};
  color: ${(p) => p.$color || "#374151"};
  border: 1px solid ${(p) => p.$border || "transparent"};
`;
